module.exports = __webpack_public_path__ + "media/images/official/plan_about_ticket-2561f21b7e290abaab6b82b7a212e8ac.png";